<template>
  <div class="trial-scheduler">
    <div v-for="wrestler in wrestlers" :key="wrestler.id" class="ibox">
      <div class="ibox-content">
        <!-- No name heading here: the picker renders the name itself (in the
             strip's header row, or above its loading/booked/empty states). -->
        <trial-class-picker
          :wrestler-id="wrestler.id"
          :wrestler-name="wrestler.name"
          @booked="markBooked(wrestler.id)"
        ></trial-class-picker>
      </div>
    </div>

    <div v-if="funnelFailed" class="alert alert-danger">{{ errorMessage }}</div>

    <!-- Exactly one CTA: booking happens inside the cards, so until everything is
         booked the only thing left to offer is a way out. -->
    <div class="flex flex-col align-items-center m-b-lg">
      <button
        v-if="remaining === 0"
        type="button"
        class="btn btn-primary"
        :disabled="leaving"
        data-cy="finish-trial-scheduling"
        @click="exit"
      >
        <i v-if="leaving" class="fa-solid fa-spinner fa-spin m-r-xxs"></i>
        Done
      </button>
      <button
        v-else
        type="button"
        class="btn btn-link text-14 text-gray-500"
        :disabled="leaving"
        data-cy="skip-trial-scheduling"
        @click="exit"
      >
        <i v-if="leaving" class="fa-solid fa-spinner fa-spin m-r-xxs"></i>
        {{ skipLabel }}
      </button>
    </div>
  </div>
</template>

<script>
import { funnelMixin } from './mixins/funnel_mix';
import TrialClassPicker from './trial_class_picker.vue';

export default {
  name: 'trial-scheduler',
  components: { TrialClassPicker },
  mixins: [funnelMixin],
  props: {
    // [{ id, name }] — one card each, ordered as the server listed them.
    wrestlers: { type: Array, required: true },
    // True when the page is the Funnel::TRIAL_SCHEDULING step. Leaving then has
    // to advance the funnel, or AccessFilter drags them back into checkout.
    funnel: { type: Boolean, default: false },
  },
  data() {
    return {
      bookedIds: [],
      leaving: false,
      // funnelMixin writes these on failure
      saving: false,
      error: false,
      errorMessage: '',
    };
  },
  computed: {
    remaining() {
      return this.wrestlers.filter((w) => !this.bookedIds.includes(w.id)).length;
    },
    skipLabel() {
      // Some booked, some not — name what's actually being deferred.
      if (this.remaining < this.wrestlers.length) {
        return this.remaining === 1
          ? "I'll schedule the other one later"
          : "I'll schedule the others later";
      }
      return "Skip for now, I'll schedule later";
    },
  },
  methods: {
    markBooked(wrestlerId) {
      if (!this.bookedIds.includes(wrestlerId)) {
        this.bookedIds.push(wrestlerId);
      }
    },
    // One exit for both buttons: end the funnel step if we're in one, otherwise
    // this was an ad-hoc visit and there's nothing to tear down.
    exit() {
      this.leaving = true;
      if (this.funnel) {
        // goToNextFunnelStep owns the redirect once the funnel is destroyed.
        this.goToNextFunnelStep();
        return;
      }
      window.location.assign('/calendar');
    },
  },
  watch: {
    funnelFailed(failed) {
      if (failed) this.leaving = false;
    },
  },
};
</script>
